import { StyleSheet } from 'aphrodite'
import React from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import UIButton from '../../components/UI/UIButton'
import UIInput from '../../components/UI/UIInput'
import { Amplify, Auth } from 'aws-amplify'
import config from '../../config/aws'
import { toast } from 'react-toastify'
import PropTypes from 'prop-types'

const styles = StyleSheet.create({
  buttonSubmit: {
    marginTop: '30px',
  },
})

export default function ForgotPassowrdForm({ onSendingMail, getMailAddress }) {
  Amplify.configure({
    Auth: config.aws,
  })

  const { t } = useTranslation('translation')
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({ mode: 'all' })

  const onSubmit = async (data) => {
    getMailAddress(data.email)
    await toast.promise(
      Auth.forgotPassword(data.email)
        .then(() => {
          onSendingMail()
          toast.success(t('pages.forgottenPassword.successMessage'))
        })
        .catch(() => toast.error(t('pages.forgottenPassword.webServiceError'))),
      {
        pending: t('pages.forgottenPassword.pendingMessage'),
      }
    )
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Controller
        name="email"
        control={control}
        render={({ field }) => (
          <UIInput
            {...field}
            label={t('pages.login.identifierOrEmail')}
            placeholder={t('pages.login.enterYourEmail')}
            errorMessage={errors.email && errors.email.message}
          />
        )}
        rules={{
          required: {
            value: true,
            message: t('common.form.errorMessage.emailEmptyError'),
          },
          pattern: {
            value:
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            message: t('common.form.errorMessage.invalidEmailEmptyError'),
          },
        }}
      />
      <UIButton
        type="submit"
        kind="button"
        design="primary"
        label={t('pages.forgottenPassword.submit')}
        fullWidth
        dynamicStyle={styles.buttonSubmit}
      />
    </form>
  )
}

ForgotPassowrdForm.propTypes = {
  onSendingMail: PropTypes.func,
  getMailAddress: PropTypes,
}
